<template>
  <component :is="layout" />
</template>

<script>
import { AppLayout, AuthLayout } from "./components/layouts";
import vuexConfig from "@/config/vuex.persist.config";

/**
 * App main root component
 */
export default {
  name: "App",
  /**
   * ---------------- Components ------------------
   */
  components: {
    AppLayout,
    AuthLayout,
  },
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {
    /**
     * Fetches current route's layout
     */
    layout() {
      const { meta } = this.$route;
      const { auth, app } = this.$appConfig.layouts;

      return `${this.isLoggedIn() ? meta.layout ?? app : auth}Layout`;
    },
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    /**
     * Checks whether user is logged in or not from the localstorage persisted data
     * @returns {Boolean} Is logged in or not
     */
    isLoggedIn() {
      return (
        JSON.parse(localStorage.getItem(vuexConfig.key))?.auth?.isLoggedIn ??
        false
      );
    },
  },
};
</script>
